import { t } from 'i18next';
import * as yup from 'yup';

import { Patterns } from 'utils/enums/validation-patterns';
import { fullNameValidationSchema } from 'utils/validations';
import { FormValidationObject } from 'views/MForm/MForm.model';
import { GenderTypes } from 'utils/enums/common';

export type IUserProfileAccessFormFields = {
  site: string;
  role: string;
};

export type IUserProfilePersonalInfoFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  gender: GenderTypes;
  dateOfBirth: moment.Moment | null;
  isCompanyAdmin: boolean;
  access: IUserProfileAccessFormFields[];
};

export const userProfilePersonalInfoInitialValues: IUserProfilePersonalInfoFormFields = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  gender: GenderTypes.Default,
  dateOfBirth: null,
  isCompanyAdmin: false,
  access: [{ site: '', role: '' }],
};

export const userProfilePersonalInfoValidationSchema = yup.object<FormValidationObject<keyof IUserProfilePersonalInfoFormFields>>({
  ...fullNameValidationSchema,
  email: yup.string().email().required(),
  phone: yup
    .string()
    .matches(new RegExp(Patterns.Phone), { message: t('userProfile.validations.phone.invalid'), excludeEmptyString: true })
    .nullable(),
  gender: yup
    .string()
    .nullable()
    .oneOf([...Object.values(GenderTypes), null]),
  dateOfBirth: yup.date().nullable(),
  isCompanyAdmin: yup.boolean(),
  access: yup.array(yup.object({ site: yup.string(), role: yup.string() })),
});
